import * as PIXI from 'pixi.js-legacy';
import Base from './Base';

import constants from '../settings/constants';

export default class DropArea extends Base {
  constructor(options) {
    super(options);

    this.ratio = options.ratio;
    this.slot = options.slot;

    this.draw(options.width, options.height);
  }

  draw() {
    const { slot, ratio } = this;
    const height = Math.ceil(constants.DROP_AREA_MAX_HEIGHT * ratio);

    const back = new PIXI.Graphics()
      .beginFill(0xfafafa)
      .drawRect(0, 0, slot.width * ratio, height)
      .endFill();

    back.alpha = 0.5;
    back.x = 1;
    back.y = 0;

    this.addChild(back);

    const arrowHeight = height;
    const arrowWidth = arrowHeight / 2;
    const arrowY = (height - arrowHeight) / 2;

    if (slot.x - slot.parent.x >= slot.parent.width) {
      const rightArrow = new PIXI.Graphics()
        .beginFill(0x407ab1)
        .drawPolygon(0, arrowHeight / 2, arrowWidth, 0, arrowWidth, arrowHeight)
        .endFill();

      rightArrow.x = 0;
      rightArrow.y = arrowY;

      this.addChild(rightArrow);
    } else {
      const leftArrow = new PIXI.Graphics()
        .beginFill(0x407ab1)
        .drawPolygon(0, 0, 0, arrowHeight, arrowWidth, arrowHeight / 2)
        .endFill();

      leftArrow.x = slot.width * ratio - leftArrow.width;
      leftArrow.y = arrowY;

      this.addChild(leftArrow);
    }
  }
}
